function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "headset",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11881",
  "data-name": "Path 11881",
  d: "M19.32,2.47A12.35,12.35,0,0,1,31.67,14.82V25.935h2.47V14.82a14.82,14.82,0,1,0-29.64,0V25.935H6.97V14.82A12.35,12.35,0,0,1,19.32,2.47Z",
  transform: "translate(-4.5)",
  fill: "#ac1ede",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11882",
  "data-name": "Path 11882",
  d: "M11.91,18.22a2.47,2.47,0,0,0-2.47-2.47H4.5v9.88A2.47,2.47,0,0,0,6.97,28.1H9.44a2.47,2.47,0,0,0,2.47-2.47Zm14.82,0a2.47,2.47,0,0,1,2.47-2.47h4.94v9.88a2.47,2.47,0,0,1-2.47,2.47H29.2a2.47,2.47,0,0,1-2.47-2.47Z",
  transform: "translate(-4.5 1.54)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11883",
  "data-name": "Path 11883",
  d: "M18.11,19.125a1.235,1.235,0,0,0-1.235,1.235v7.41a6.175,6.175,0,0,0,6.175,6.175H31.7a1.235,1.235,0,0,0,0-2.47H23.05a3.705,3.705,0,0,1-3.705-3.705V20.36A1.235,1.235,0,0,0,18.11,19.125Z",
  transform: "translate(-16.875 1.87)",
  fill: "#ac1ede",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11884",
  "data-name": "Path 11884",
  d: "M22.035,31.72a2.47,2.47,0,0,0-2.47-2.47H17.1a2.47,2.47,0,1,0,0,4.94h2.47A2.47,2.47,0,0,0,22.035,31.72Z",
  transform: "translate(-3.51 2.86)",
  fill: "#ac1ede"
}));

var SvgHeadset = function SvgHeadset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.64,
    height: 37.05,
    viewBox: "0 0 29.64 37.05",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeadset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/headset.cde39704.svg";
export { ForwardRef as ReactComponent };